/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback } from "react";
import Pagination from "components/Pagination/Pagination";
import TableOrder from "components/Tables/TableOrder";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import ConfigurationHeader from "../ConfigurationHeader";
import { useState } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { __CountUser } from "request/configuration/__CountUser";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import environment from "constants/apiConst";
import { TbodyCountUser } from "../tables/TbodyCountUser";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { FormAccesUser } from "../forms/FormAccesUser";
import { FormAcessShow } from "../FormShow/FormAcessShow";
import { useSelector } from "react-redux";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useGlobalContext } from "context/GlobalContext";
import InputSelect from "components/InputSelect/InputSelect";
import { useZonasFrancaNotPaginate } from "hooks/useZonasFranca";
import { Box } from "@chakra-ui/react";

const formEdit = () => {
  return <FormAccesUser />;
};

const formShow = () => {
  return <FormAcessShow />;
};

export const CountUser = () => {
  const [currentPage, setCurrentPage] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [freeZoneFilter, setFreeZoneFilter] = useState(null);
  const { token } = useSelector((state) => state.auth.dataUser);
  const {
    setRequestEdit,
    setRequestCreate,
    setFormEdit,
    setFormShow,
    update,
    setRequestCreateLicense
  } = useContext(ConfigurationCRUDContext);
  const location = useLocation();
  const { q = "" } = queryString.parse(location.search);

  const tHead = [
    { name: "Usuario", order: "user" },
    { name: "Correo", order: "email" },
    { name: "Nombre", order: "name_person" },
    { name: "Apellido", order: "lastname_person" },
    { name: "Zona Franca", order: "name_freeZone" },
    { name: "Acceso admin.", order: "staff_status" },
    { name: "Estado", order: "status" },
    { name: "Acciones", order: "actions" }
  ];

  const { data: zonasFrancaData } = useZonasFrancaNotPaginate(token);

  useEffect(() => {
    setFormShow(formShow);
    setFormEdit(formEdit);
  }, [
    setFormShow,
    setFormEdit,
    setRequestEdit,
    setRequestCreate
  ]);

  useEffect(() => {
    setRequestEdit(environment.USER_ACCES_UPDATE);
    setRequestCreate(environment.USER_ACCES_CREATE);
    setRequestCreateLicense(environment.LICENSES_CREATE);
  }, []);

  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["userAccess", page, q, freeZoneFilter?.value],
    queryFn: () => requestData({
      Endpoint: environment.GET_USER_ACCES,
      pageParam: page,
      data: {
        ...(q?.length !== 0 && { search: q }),
        ...(freeZoneFilter?.value && { free_zone_id: freeZoneFilter.value }),
      },
      PropertyBody: "sendJSONContentPOST"
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  useEffect(() => {
    setPage(1);
  }, [freeZoneFilter]);

  return (
    <>
      <SectionContainerGene>
        <ConfigurationHeader
          title={"Cuentas de usuarios"}
        >
          <Box minW="220px">
            <InputSelect
              tag={"Filtrar por Zona Franca"}
              data={zonasFrancaData || []}
              set={setFreeZoneFilter}
              value={freeZoneFilter}
            />
          </Box>
        </ConfigurationHeader>
        {isLoading || (
          <TableOrder
            thead={tHead}
            data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
            setData={setCurrentPage}
            loading={isLoading}
            tbodyData={TbodyCountUser}
          />
        )}
        <Pagination
          page={page}
          setPage={setPage}
          maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
          loading={isLoading}
        />
      </SectionContainerGene>
    </>
  );
};
